import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoPrestacionEmpleadosHogar = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoPrestacionEmpleadosHogar = () => {
  const [loadingGetInfoPrestacionEmpleadosHogar, setLoadingGetInfoPrestacionEmpleadosHogar] = useState(false);
  const [successGetInfoPrestacionEmpleadosHogar, setSuccessGetInfoPrestacionEmpleadosHogar] = useState(false);
  const [errorGetInfoPrestacionEmpleadosHogar, setErrorGetInfoPrestacionEmpleadosHogar] = useState<any>(null);
  const [dataGetInfoPrestacionEmpleadosHogar, setDataGetInfoPrestacionEmpleadosHogar] = useState<any>(null);

  const [statusGetInfoPrestacionEmpleadosHogar, setStatusGetInfoPrestacionEmpleadosHogar] =
    useState<StatusGetInfoPrestacionEmpleadosHogar>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoPrestacionEmpleadosHogar = async (
    userId: any,
    expedienteId: string = null,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoPrestacionEmpleadosHogar(true);
    setSuccessGetInfoPrestacionEmpleadosHogar(false);
    setErrorGetInfoPrestacionEmpleadosHogar(null);

    try {
      const res = await apiRecord.getInfoCertificadoPrestacionEmpleoHogar(userId, expedienteId);

      setStatusGetInfoPrestacionEmpleadosHogar({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoPrestacionEmpleadosHogar(true);
      setDataGetInfoPrestacionEmpleadosHogar(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;
    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetInfoPrestacionEmpleadosHogar({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoPrestacionEmpleadosHogar(err);
      console.error("Error en getInfoPrestacionEmpleadosHogar:", err);

      throw err;

    } finally {
      setLoadingGetInfoPrestacionEmpleadosHogar(false);
    }
  };

  return {
    getInfoPrestacionEmpleadosHogar,
    loadingGetInfoPrestacionEmpleadosHogar,
    successGetInfoPrestacionEmpleadosHogar,
    errorGetInfoPrestacionEmpleadosHogar,
    dataGetInfoPrestacionEmpleadosHogar,
    statusGetInfoPrestacionEmpleadosHogar
  };
};

export default useGetInfoPrestacionEmpleadosHogar;
